<template>
  <section class="card-list">
    <div class="card-list_title">
      <div class="hgroup">
        <h1 class="heading1">{{$t('Мои карты')}}</h1>
        <a v-if="cards.length > 0" class="title-info title-info__link title-info__addcard" href="#" @click.prevent="onAddCardButtonClick">
          {{ $t('Добавить карту') }}
        </a>
      </div>
    </div>
    <ul class="card-list_list">
      <li class="card-list_item" v-for="card in cards" :key="card.id">
        <Card :card="card" :key="card.id" />
      </li>
      <li class="card-list_item" v-if="cards.length === 0">
        <CardPlaceholder />
      </li>
    </ul>

    <Portal to="overlay" v-if="showBindDialog">
      <CardBindDialog @close="showBindDialog = false" />
    </Portal>
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import Card from './Card/Card.vue'
import CardPlaceholder from './Card/CardPlaceholder.vue'

import CardBindDialog from '@/components/CardBindDialog.vue'

@Component({
  components: { Card, CardPlaceholder, CardBindDialog }
})
class CardList extends Vue {
  @Prop({ type: Array, required: true }) cards

  showBindDialog = false

  onAddCardButtonClick () {
    this.showBindDialog = true
    this.$analytics.trackAddCardButtonClick({ screenId: this.$route.name })
  }
}

export default CardList
</script>

<style lang="scss">
  .card-list {
    border-top: 1px solid #303030;
    position: relative;

    &_title {
      @extend %layout;
      left: 0;
      position: absolute;
      right: 0;
      z-index: 1;
    }
    &_item {
      border-bottom: 1px solid #303030;
    }
  }
</style>
